import clsx from 'clsx';

import { ButtonV2 } from 'component-lib/atoms/button-v2/ButtonV2';
import { Icon } from 'component-lib/atoms/icon/Icon';

export interface IconButtonProps extends React.ComponentPropsWithoutRef<'button'> {
  active?: boolean;
  iconLeft?: string;
  iconRight?: string;
  loading?: boolean;
}

const Prefix = ({ name }: { name: string }) => <Icon name={name} className="text-base/none text-current" />;
const Postfix = ({ name }: { name: string }) => <Icon name={name} className="text-base/none text-current" />;
const LoadingContent = ({ loading, children }: { loading?: boolean; children?: React.ReactNode }) =>
  loading ? (
    <Icon
      aria-label="loading"
      name="circle-loader"
      className="animate-spin transition-all duration-fast leading-loose"
    />
  ) : (
    <>{children}</>
  );

/**
 * @deprecated Use `<ButtonV2 variant="primary"/>`
 */
export const FillButton = ({ loading, disabled, iconLeft, iconRight, children, ...rest }: IconButtonProps) => (
  <ButtonV2
    variant="primary"
    disabled={loading || disabled}
    prefix={iconLeft && <Prefix name={iconLeft} />}
    postfix={iconRight && <Postfix name={iconRight} />}
    {...rest}
  >
    <LoadingContent loading={loading}>{children}</LoadingContent>
  </ButtonV2>
);

/**
 * @deprecated Use `<ButtonV2 variant="outline"/>`
 */
export const GhostButton = ({ loading, disabled, iconLeft, iconRight, children, ...rest }: IconButtonProps) => (
  <ButtonV2
    disabled={loading || disabled}
    prefix={iconLeft && <Prefix name={iconLeft} />}
    postfix={iconRight && <Postfix name={iconRight} />}
    {...rest}
  >
    <LoadingContent loading={loading}>{children}</LoadingContent>
  </ButtonV2>
);

/**
 * @deprecated Use `<ButtonV2 variant="primary"/>` (remove the borders if you must, or just use `<Link />`)
 */
export const TextButton = ({
  loading,
  disabled,
  iconLeft,
  iconRight,
  children,
  className,
  ...rest
}: IconButtonProps) => (
  <ButtonV2
    disabled={loading || disabled}
    prefix={iconLeft && <Prefix name={iconLeft} />}
    postfix={iconRight && <Postfix name={iconRight} />}
    className={clsx('border-none !bg-transparent !text-base !font-normal !px-0 !ring-0', className)}
    {...rest}
  >
    <LoadingContent loading={loading}>{children}</LoadingContent>
  </ButtonV2>
);
